// @flow
import type {Node} from 'react'
import React from 'react'
import {compose, defaultTo, path} from 'ramda'
import {parseISO, format, isValid} from 'date-fns'

import {configWithLocale} from 'utils/dateFnsLocale'
import ChangeTitle from 'components/proposals/Part/ui/Summary/ChangeTitle'
import SummaryUI from '../../ui/Summary'
import type {State} from '../types'

const nameOrTbd = (person) => compose(defaultTo(I18n.t('proposals.role_elect.to_be_determined')), path(['name']))(person)

const formatDate = (dateString) => {
  const date = parseISO(dateString)

  return isValid(date)
    ? format(date, 'P', configWithLocale)
    : ''
}

const localizedDate = ({nextValue}) => (
  nextValue
    ? formatDate(nextValue)
    : I18n.t('proposals.role_elect.to_be_determined')
)

type Props = State

function Summary({assignedUntil, person}: Props): Node {
  return (
    <SummaryUI lostChanges={false}>
      <div className="proposal-summary-elect-role">
        <ChangeTitle title={I18n.t('proposals.role_elect.candidate')} />
        <div className="proposal-summary-elect-role__candidate-name">
          {nameOrTbd(person)}
        </div>
        <ChangeTitle title={I18n.t('proposals.role_elect.until')} />
        <div className="proposal-summary-elect-role__assigned-until-date">
          {localizedDate(assignedUntil)}
        </div>
      </div>
    </SummaryUI>
  )
}

export default Summary
